import { createModel } from "nyax";
import { WorkflowLayout, WorkflowLayoutQuery } from "src/models/workflowLayout";
import { WorkflowLayoutEntityModel } from "src/store/models/entity/workflowLayout/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const WorkflowLayoutSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<WorkflowLayout, WorkflowLayoutQuery>({
    setItems: (getContainer, items) =>
      getContainer(WorkflowLayoutEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(WorkflowLayoutEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(WorkflowLayoutEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: WorkflowLayoutQuery
            ) =>
              this.dependencies.serviceClient.workflowLayout.list(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
